<template>
  <div class="system-breakdown dialog-box">
    <van-popup
      v-model="system_error_data.show_dialog"
      :close-on-click-overlay="false"
    >
      <div class="content">
        <div class="error-back">
          <img
            class="error-img"
            src="../../../assets/images/dialog/dialog-viphome.png"
            alt=""
          />
        </div>
        <div class="error-msg">{{ system_error_data.content }}</div>
        <div
          class="btn"
          :class="system_error_data.residue === 0 ? 'disabled-btn' : ''"
          @click="updateHurryUpSystemError"
        >
          {{ system_error_data.residue > 0 ? '催一下' : '已催' }}
        </div>
        <div class="fotter-tip">
          已有{{ system_error_data.times }}人催了一下
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState({
      system_error_data: 'system_error_data'
    })
  },
  methods: {
    ...mapActions({
      updateHurryUpSystemError: 'updateHurryUpSystemError'
    }),
  }
}
</script>
<style lang="scss" scoped>
.system-breakdown {
  .content {
    .error-back {
      text-align: center;
    }
    .error-img {
      width: 400px;
      height: 400px;
      text-align: center;
    }
    .error-msg {
      font-size: 28px;
      font-family: HappyZcool;
      font-weight: 400;
      line-height: 36px;
      color: rgba(40, 40, 40, 1);
      margin-top: 20px;
      padding: 0 60px;
    }
    .btn {
      background-color: #ff9807;
      text-align: center;
      color: #ffffff;
      font-size: 28px;
      line-height: 80px;
      border-radius: 4px;
      margin: 40px 60px;
    }
    .disabled-btn {
      background-color: #cccccc;
    }
    .fotter-tip {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 36px;
      color: rgba(204, 204, 204, 1);
      margin-bottom: 30px;
      text-align: center;
    }
  }
}
</style>
